import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, PagePanel, Tabs } from 'edenred-ui';

import { getApplicationLocale } from '@epi-store/application/application.selectors';
import { getUserCompany } from '@epi-actions/api';
import { getCustomerNumber } from '@epi-selectors/api';
import BeneficiariesList from '@epi-pages/Beneficiaries/BeneficiariesList';
import { TabsManageEmployees } from '@epi-constants/manageEmployees';
import OnboardingStepper from '@epi-components/OnboardingStepper/OnboardingStepper';
import { OnboardingSupportInformation } from '@epi-components/OnboardingSupportInformation';
import config from '@epi-config';

import { useManageEmployeesTabs } from './hooks/useManageEmployeesTabs';
import { useBeneficiariesList } from '@epi-pages/Beneficiaries/hooks';
import { MassUpload } from '@epi-pages/MassUpload';

const ManageEmployeesTabs = () => {
  const { enableMassUpload } = config;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const locale = useSelector(getApplicationLocale);
  const companyId = useSelector(getCustomerNumber);
  const [isLoading, setIsLoading] = useState(false);
  const { handleOnTabChange, defaultTabName, hasEmployees } =
    useManageEmployeesTabs();

  const { footer } = useBeneficiariesList();

  useEffect(() => {
    dispatch(getUserCompany());
  }, []);

  useEffect(() => {
    setIsLoading(true);
    setIsLoading(false);
  }, [locale]);

  const beneficiaries = {
    name: TabsManageEmployees.employees,
    label: t('containers.beneficiaries.tabs.employees'),
    id: 'tab-employees',
    body: <BeneficiariesList />
  };

  const massUpload = {
    name: TabsManageEmployees.massUpload,
    label: t('containers.beneficiaries.tabs.hr_import_history.title'),
    id: 'tab-hr-import-history',
    body: <MassUpload />
  };

  const tabs = [beneficiaries, ...(enableMassUpload ? [massUpload] : [])];

  return (
    <Box>
      <OnboardingStepper />
      <PagePanel title={t('containers.beneficiaries.title')} footer={footer}>
        {!isLoading && companyId && (
          <>
            {hasEmployees ? (
              <Tabs
                tabs={tabs}
                onTabChange={handleOnTabChange}
                defaultTabName={defaultTabName}
              />
            ) : (
              <BeneficiariesList />
            )}
          </>
        )}
      </PagePanel>
      <OnboardingSupportInformation />
    </Box>
  );
};

export default ManageEmployeesTabs;
